import React from 'react'
import filter from 'lodash/filter'
import map from 'lodash/map'
import Tooltip from '@mui/material/Tooltip'
import { t } from '../../../i18n'
import Icon from '../../shared/icon'
import ReplenishmentOrderExport from './OrderExport'
import { ReplenishmentOrderItem } from './OrderItem'
import axios from 'axios'

const scope = 'replenishment.sidebar.history'

const ReplenishmentHistoryOrder = ({ replenishmentOrder, closeSidebar, cancelItem, weightScale }) => {

  const activeOrder = () => {
    return ['sent', 'closed'].includes(replenishmentOrder.state)
  }

  const productReplenishmentsOfType = (type: 'solid' | 'liquid') => {
    const productReplenishments = filter(replenishmentOrder.productReplenishments, replenishment =>
      replenishment.containerType === type && !replenishment.destroy
    )
    const header = type.charAt(0).toUpperCase() + type.slice(1)

    if(!productReplenishments.length) return
    return (
      <div className={`${type}-ingredients`} style={{marginTop: '20px'}}>
        <span className='sidebar-heading replenishment-order-subcategory'>{header} ingredients</span>
        {map(productReplenishments, (replenishment, index) =>
          <ReplenishmentOrderItem
            key={`${replenishment.product.id}-${index}`}
            type="product"
            orderItem={replenishment}
            index={index}
            showRemove={false}
            cancelable={activeOrder()}
            cancelItem={cancelItem}
          />
        )}
      </div>
    )
  }

  const plateReplenishments = () => {
    if(!replenishmentOrder.plateReplenishments.length) return
    const plateReplenishments = replenishmentOrder.plateReplenishments.filter(replenishment => !replenishment.destroy)
    return (
      <div className="plates" style={{marginTop: '20px'}}>
        <span className='sidebar-heading replenishment-order-subcategory'>{t('bowls', { scope })}</span>
        {map(plateReplenishments, (replenishment, index) =>
          <ReplenishmentOrderItem
            key={`${replenishment.slotNumber}-${index}`}
            type="plates"
            orderItem={replenishment}
            index={index}
            showRemove={false}
            cancelable={activeOrder()}
            cancelItem={cancelItem}
          />
        )}
      </div>
    )
  }

  const oilReplenishment = () => {
    const replenishment = replenishmentOrder.oilReplenishment

    if(!replenishment) {
      return null
    }

    return (
      <div className="plates" style={{marginTop: '20px'}}>
        <span className='sidebar-heading replenishment-order-subcategory'>{t('oil', { scope })}</span>
          <ReplenishmentOrderItem
            key='oil-replenishment'
            type="oil"
            index={1}
            orderItem={replenishment}
            showRemove={false}
            cancelable={activeOrder()}
            cancelItem={cancelItem}
            weightScale={weightScale}
          />
      </div>
    )
  }

  const changeHistoryUrl = `/replenishment_orders/${replenishmentOrder.id}/product_replenishments_history`

  return (
    <>
      <div className="sidebar-top">
        <div className='sidebar-header'>
          <Tooltip title="Click to view order change history" placement='bottom' arrow>
            <span className='sidebar-heading'>
              <a href={changeHistoryUrl} target="_blank" rel="noopener noreferrer">
                {t('order_name', { scope, orderId: replenishmentOrder.id})}
                <div style={{ display: 'inline-block', marginLeft: '5px' }}><Icon name='external' /></div>
              </a>
            </span>
          </Tooltip>
          <Icon name='close' className="close-icon" onClick={closeSidebar}/>
        </div>
      </div>
      <div>
        {productReplenishmentsOfType('solid')}
        {productReplenishmentsOfType('liquid')}
        {plateReplenishments()}
        {oilReplenishment()}
        <ReplenishmentOrderExport replenishmentOrder={replenishmentOrder}/>
      </div>
    </>
  )
}

export default ReplenishmentHistoryOrder
